/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConsultationApiConfiguration, ConsultationApiConfigurationParams } from './consultation-api-configuration';

import { ConsultationEncounterService } from './services/consultation-encounter.service';
import { ConsultationMedicationService } from './services/consultation-medication.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ConsultationEncounterService,
    ConsultationMedicationService,
    ConsultationApiConfiguration
  ],
})
export class ConsultationModule {
  static forRoot(params: ConsultationApiConfigurationParams): ModuleWithProviders<ConsultationModule> {
    return {
      ngModule: ConsultationModule,
      providers: [
        {
          provide: ConsultationApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ConsultationModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ConsultationModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
